import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ExportCertificateReportService } from 'src/app/services/export-certificate-report.service';
import { convertBase64ToPdfUrl, downloadFileFromUrl } from 'src/app/variables/common';

@Component({
  selector: 'app-export-file-popup',
  templateUrl: './export-file-popup.component.html',
  styleUrls: ['./export-file-popup.component.scss']
})
export class ExportFilePopupComponent {
  selectExportType!: string;
  filterReq: any;
  selectedFiles: any[];
  exportAPIRequest!: any;
  isLoading: boolean = false;
  constructor(
    private exportCertificateReportService: ExportCertificateReportService,
    private activeModel: NgbActiveModal
  ) { }

  // Close modal (Bootstrap way)
  close(): void {
    this.activeModel.close(true);
  }

  // Main export logic
  export() {
    this.isLoading = true;
    switch (this.selectExportType) {
      case "0":
        this.onExportWithPDF();
        break;

      case "1":
        //  direct download
        this.exportCertificatesReportToExcel();
        break;

      case "2":
        if (this.selectedFiles?.length) {
          this.onExportWithPDF();
        } else {
          alert("Please select Certificates");
        }
        break;

      case "3":
        //  direct download
        if (this.selectedFiles?.length) {
          this.exportCertificatesReportToExcel();
        } else {
          alert("Please select Certificates");
        }
        break;

      default:
        break;
    }
  }


  onExportWithPDF() {
    this.exportCertificateReportService.reset();
    this.exportCertificateReportService.setLoading(true);
    this.exportCertificateReportService.setExportData(this.filterReq);
    localStorage.setItem(
      "export_certificate_report_data",
      JSON.stringify(this.filterReq)
    );
    this.close();
  }

  exportCertificatesReportToExcel() {
    this.exportCertificateReportService.exportValidInvalidCertificates(this.filterReq).subscribe((res: any) => {
      this.downloadLogFile(res?.file);
      this.close();
    }, (error) => {
      this.close();
      alert(
        error?.ResponseException || "Something Went Wrong !"
      );
    });
  }

  downloadLogFile(file: any) {
    try {
      const url = convertBase64ToPdfUrl(file?.fileContents, file?.contentType);
      downloadFileFromUrl(url, file?.fileDownloadName);
      this.close();
    } catch (err: any) {
      this.close();
      alert(err?.error?.responseException?.exceptionMessage?.ResponseException || "Something Went Wrong !");
    }
  }
}
